module.exports = __webpack_public_path__ + "img/transfer.e26f7839.svg";